import {TheBorderScatterSymbol} from "../reels/TheBorderScatterSymbol";
import {TheBorder} from "../TheBorder";
import {ISymbolPosition} from "../../core/reel/ReelInterfaces";
import {gsap, TimelineLite} from "gsap";
import {TheBorderSound} from "../sound/TheBorderSound";

/**
 * Created by Jerker Nord on 2022-05-13.
 */

export class TheBorderScatterSymbols {

    private _scatterSymbols: TheBorderScatterSymbol[];

    constructor() {
    }

    public init(): void {
        this._scatterSymbols = [];
        for (let i: number = 0; i < 6; i++) {
            this._scatterSymbols.push(this.createNewScatterSymbol());
        }

        const tempSym: TheBorderScatterSymbol = this.createNewScatterSymbol();
        TheBorder.gpuPushView.addChild(tempSym);
        tempSym.visible = true;
        gsap.timeline({delay: TheBorder.gpuPushView.delay}).add(tempSym.getLandingAndIdleAnimation().restart());
    }

    // #324
    public animateAllForWin(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        tl.add(() => {
            TheBorder.soundPlayer.playSound(TheBorderSound.SCATTER_UNLOCK_BOUNCE);
        });
        for (let i: number = 0; i < this._scatterSymbols.length; i++) {
            if (this._scatterSymbols[i].isUsed) {
                tl.add(this._scatterSymbols[i].getWinAnimation(), 0);
            }
        }

        return tl;
    }

    public getAllUsedSymbols(): TheBorderScatterSymbol[] {
        return this._scatterSymbols.filter((sym: TheBorderScatterSymbol) => {
            return (sym.isUsed && sym.isSpinOut == false);
        });
    }

    public getScatterSymbol(symbolPositionData: ISymbolPosition): TheBorderScatterSymbol {
        for (let i: number = 0; i < this._scatterSymbols.length; i++) {
            if (!this._scatterSymbols[i].isUsed) {
                this._scatterSymbols[i].isUsed = true;
                this._scatterSymbols[i].isRemoved = false;
                this._scatterSymbols[i].reelId = symbolPositionData.reelId;
                this._scatterSymbols[i].reelPosition = symbolPositionData.startPosition;
                return this._scatterSymbols[i];
            }
        }
        this._scatterSymbols.push(this.createNewScatterSymbol());
        return this.getScatterSymbol(symbolPositionData);
    }

    public turnOffAllScatterSymbols(): void {
        for (let i: number = 0; i < this._scatterSymbols.length; i++) {
            if (this._scatterSymbols[i].isUsed) {
                this._scatterSymbols[i].turnOffSymbolSpine();
            }
        }
    }

    private createNewScatterSymbol(): TheBorderScatterSymbol {
        return new TheBorderScatterSymbol();
    }
}